export { default } from './sold-statistics';
